import React from 'react';

import {
  Check,
  Close
} from '@mui/icons-material';



export interface IProps {
  success: boolean;
}

export const FC: React.FC<IProps> = props => {
  return props.success ? <Check color="success" /> : <Close color="error" />;
};
